import React, { useState } from "react";
import {
  Row,
  Table,
  Form,
  Button,
  Col,
  Space,
  Input,
  DatePicker,
  InputNumber,
  Select,
} from "antd";
import {
  MinusCircleOutlined,
  PlusOutlined,
  SendOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useFetchConstant } from "apis/constant";
import moment from "moment";

import SectionCard from "components/SectionCard/SectionCard";
import SectionContainer from "components/SectionContainer/SectionContainer";

import { getLabelOfConstant } from "utils/general";

import AddNomineeModal from "../AddNomineeModal/AddNomineeModal";
import { DescriptionForLabel, Label } from "./Nomination.styles";

import EditableTable from "components/EditableTable/EditableTable";
import { constructDisplayPrice } from "utils/general";
import { ScreenSize } from "utils/constants";
import Locale from "react-intl-universal";

const constructNominationsTableColumns = (
  relationships = [],
  nominationTypes = []
) => [
  {
    dataIndex: "name",
    key: "name",
    render: (value, record) => (
      <div>
        <Label>{value}</Label>
        <DescriptionForLabel>
          {getLabelOfConstant(record.type, nominationTypes) || record.type}
        </DescriptionForLabel>
      </div>
    ),
  },
  {
    dataIndex: "relationship",
    key: "relationship",
    render: (value) => <span>{getLabelOfConstant(value, relationships)}</span>,
  },
];

const Nomination = ({
  nominations = [],
  updateNominations,
  form,
  benefitShareCheck,
}) => {
  // const [form] = Form.useForm();
  const [showNomineeModal, setShowNomineeModal] = useState(false);
  const [selectedNomineeIndex, setSelectedNomineeIndex] = useState(-1);
  const {
    isLoading: isNominationTypesLoading,
    selection: nominationTypes,
  } = useFetchConstant("nominationTypes");
  const {
    isLoading: isRelationshipsLoading,
    selection: relationships,
  } = useFetchConstant("relationships");
  const isConstantsLoading = isNominationTypesLoading || isRelationshipsLoading;

  const handleOnNomineeRowSelect = (index) => {
    setShowNomineeModal(true);
    setSelectedNomineeIndex(index);
  };

  const handleOnAddNomineeModalOkButtonClick = (newNominee) => {
    let newNominees = [...nominations];
    if (selectedNomineeIndex > -1) {
      newNominees[selectedNomineeIndex] = newNominee;
    } else {
      newNominees = [...nominations, newNominee];
    }
    updateNominations(newNominees);
    setShowNomineeModal(false);
    setSelectedNomineeIndex(-1);
  };

  const handleOnAddNomineeModalRemoveButtonClick = () => {
    const newNominees = [...nominations];
    newNominees.splice(selectedNomineeIndex, 1);
    setShowNomineeModal(false);
    updateNominations(newNominees);
    setSelectedNomineeIndex(-1);
  };

  const handleOnAddNomineeModalCloseButtonClick = () => {
    setShowNomineeModal(false);
    setSelectedNomineeIndex(-1);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      console.log(values, 87);
    } catch (error) {
      console.log(error, 89);
    }
  };

  const LabelStyle = {
    backgroundColor: "#FAFAFA",
    padding: "12px 8px",
    fontWeight: 500,
    color: "black",
    borderRight: "1px solid rgba(0,0,0,0.05)",
  };

  const FormStyle = {
    padding: "12px 8px",
    height: 85,
    borderRight: "1px solid rgba(0,0,0,0.05)",
    borderBottom: "1px solid rgba(0,0,0,0.05)",
  };

  const NomidationDetails = (
    <SectionContainer>
      <SectionCard
        loading={isConstantsLoading}
        title={Locale.get("ownedPolicies.nominationTab.nominationDetail")}
        // buttonText="Add Nominee"
        // onActionButtonClick={() => setShowNomineeModal(true)}
      >
        <div
          style={{
            marginBottom: 24,
            border: "1px solid rgba(0,0,0,0.05)",
            overflowX: "auto",
            fontSize: 12,
          }}
        >
          <Row
            style={{
              height: 50,
              width: window.innerWidth < ScreenSize.xl ? "600%" : "100%",
            }}
          >
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.idenType")}
            </Col>
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.idenNo")}
            </Col>
            <Col span={5} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.name")}
            </Col>
            <Col span={2} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.benefitShare")}
            </Col>
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.relation")}
            </Col>
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.contactNo")}
            </Col>
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.trustee")}
            </Col>
            <Col span={2} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.action")}
            </Col>
          </Row>

          <div>
            <Form.List name="nominations">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => {
                    // console.log(key, name);
                    // console.log(form.getFieldValue('nomination'));

                    return (
                      <Row
                        key={key}
                        style={{
                          width:
                            window.innerWidth < ScreenSize.xl ? "600%" : "100%",
                        }}
                      >
                        {/* <Col span={2} style={FormStyle}>
                          <Form.Item noStyle shouldUpdate>
                            {({ setFieldsValue, getFieldValue }) => (
                              <Form.Item
                                {...restField}
                                name={[name, 'fromDate']}
                                rules={[
                                  {
                                    required: false,
                                    message: 'From Date is required'
                                  }
                                ]}
                                // valuePropName for prevent error while setFieldValue
                                // and manual set DatePicker defaultValue
                                // only use for Form.List
                                valuePropName="date">
                                <DatePicker
                                  defaultValue={
                                    getFieldValue('nomination')[name]?.fromDate
                                      ? moment(
                                          getFieldValue('nomination')[name]
                                            ?.fromDate
                                        )
                                      : null
                                  }
                                  onChange={(e) => {
                                    if (!e || e) {
                                      form.setFields([
                                        {
                                          name: ['nomination', name, 'toDate'],
                                          value: null
                                        }
                                      ]);
                                    }
                                  }}
                                />
                              </Form.Item>
                            )}
                          </Form.Item>
                        </Col>

                        <Col span={2} style={FormStyle}>
                          <Form.Item noStyle shouldUpdate>
                            {({ getFieldValue }) => (
                              <Form.Item
                                {...restField}
                                name={[name, 'toDate']}
                                rules={[
                                  {
                                    required: false,
                                    message: 'To Date is required'
                                  }
                                ]}
                                // valuePropName for prevent error while setFieldValue
                                // and manual set DatePicker defaultValue
                                // only use for Form.List
                                valuePropName="date">
                                <DatePicker
                                  defaultValue={
                                    getFieldValue('nomination')[name]?.toDate
                                      ? moment(
                                          getFieldValue('nomination')[name]
                                            ?.toDate
                                        )
                                      : null
                                  }
                                  disabled={
                                    !getFieldValue('nomination')[name]?.fromDate
                                  }
                                  disabledDate={(e) =>
                                    e &&
                                    e <
                                      moment(
                                        getFieldValue('nomination')[name]
                                          ?.fromDate
                                      ).endOf('day')
                                  }
                                  // disabledDate={(e) => e && e > moment().endOf('day')}
                                />
                              </Form.Item>
                            )}
                          </Form.Item>
                        </Col> */}

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "identityType"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgIdenType"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.idenType"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "identityNumber"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgIdenNo"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.idenNo"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={5} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "name"]}
                            rules={[
                              {
                                required: true,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgName"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.name"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={2} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "benefitShare"]}
                            rules={[
                              {
                                required: true,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgBenefitShare"
                                ),
                              },
                            ]}
                          >
                            <InputNumber
                              style={{
                                width: "100%",
                                border: benefitShareCheck && "1px solid red",
                              }}
                              max={100}
                              min={0}
                              precision={0}
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.benefitShare"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "relationship"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgRelation"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.relation"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            // hasFeedback
                            // label={'Contact :'}
                            name={[name, "contactNumber"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgContactNo"
                                ),
                              },
                              // {
                              //   min: 9,
                              //   message:
                              //     "Contact Number must not less than 9 digit",
                              // },
                              // {
                              //   max: 12,
                              //   message:
                              //     "Contact Number no must not more than 12 digit",
                              // },
                              // {
                              //   pattern: RegExp(/^\d+$/),
                              //   message: "Contact Number must be number only",
                              // },

                              // {
                              //   validator: (rule, value) => {
                              //     if (value.length === 10 || value.length === 11) {
                              //       return Promise.resolve();
                              //     } else {
                              //       return Promise.reject(
                              //         "Contact number must between 10 or 11 digits"
                              //       );
                              //     }
                              //   },
                              // },
                            ]}
                          >
                            <Input
                              /* prefix="+60" */ /* placeholder="01234567890" */ placeholder={Locale.get(
                                "ownedPolicies.nominationTab.contactNo"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "trustNonTrust"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgTrustee"
                                ),
                              },
                            ]}
                          >
                            <Select
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.trustee"
                              )}
                            >
                              <Select.Option value="trust">
                                {Locale.get(
                                  "ownedPolicies.nominationTab.trust"
                                )}
                              </Select.Option>
                              <Select.Option value="nonTrust">
                                {Locale.get(
                                  "ownedPolicies.nominationTab.nonTrust"
                                )}
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={2} style={FormStyle}>
                          <Row justify="center">
                            <Button
                              type="link"
                              style={{ color: "red" }}
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                            >
                              {Locale.get("ownedPolicies.nominationTab.delete")}
                            </Button>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => (
                      <Row
                        style={{
                          // borderTop: '1px solid rgba(0,0,0,0.05)',
                          marginTop: 32,
                          // paddingTop: 24,
                          marginLeft: 32,
                          // width: window.innerWidth < ScreenSize.xl ? "400%" : "200%"
                        }}
                      >
                        <Col>
                          <Button
                            style={{
                              width: 300,
                              borderColor: "#d7a301",
                              color: "#d7a301",
                            }}
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            {Locale.get(
                              "ownedPolicies.nominationTab.addFieldButton"
                            )}
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
        </div>
      </SectionCard>
    </SectionContainer>
  );

  const TrusteeDetails = (
    <SectionContainer>
      <SectionCard
        loading={isConstantsLoading}
        title={Locale.get("ownedPolicies.nominationTab.trusteeDetail")}
        // buttonText="Add Nominee"
        // onActionButtonClick={() => setShowNomineeModal(true)}
      >
        <div
          style={{
            marginBottom: 24,
            border: "1px solid rgba(0,0,0,0.05)",
            overflowX: "auto",
            fontSize: 12,
          }}
        >
          <Row
            style={{
              height: 50,
              width: window.innerWidth < ScreenSize.xl ? "600%" : "100%",
            }}
          >
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.indComp")}
            </Col>
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.idenNo")}
            </Col>
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.idenType")}
            </Col>
            <Col span={10} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.indCompName")}
            </Col>
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.contactNo")}
            </Col>
            <Col span={2} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.action")}
            </Col>
          </Row>

          <div>
            <Form.List name="trustee">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => {
                    // console.log(key, name);

                    return (
                      <Row
                        key={key}
                        style={{
                          width:
                            window.innerWidth < ScreenSize.xl ? "600%" : "100%",
                        }}
                      >
                        {/* <Col span={2} style={FormStyle}>
                          <Form.Item noStyle shouldUpdate>
                            {({ getFieldValue }) => (
                              <Form.Item
                                {...restField}
                                name={[name, 'fromDate']}
                                rules={[
                                  {
                                    required: false,
                                    message: 'From Date is required'
                                  }
                                ]}
                                // valuePropName for prevent error while setFieldValue
                                // and manual set DatePicker defaultValue
                                // only use for Form.List
                                valuePropName="date">
                                <DatePicker
                                  defaultValue={
                                    getFieldValue('trustee')[name]?.fromDate
                                      ? moment(
                                          getFieldValue('trustee')[name]
                                            ?.fromDate
                                        )
                                      : null
                                  }
                                  onChange={(e) => {
                                    if (!e || e) {
                                      form.setFields([
                                        {
                                          name: ['trustee', name, 'toDate'],
                                          value: null
                                        }
                                      ]);
                                    }
                                  }}
                                />
                              </Form.Item>
                            )}
                          </Form.Item>
                        </Col>

                        <Col span={2} style={FormStyle}>
                          <Form.Item noStyle shouldUpdate>
                            {({ getFieldValue }) => (
                              <Form.Item
                                {...restField}
                                name={[name, 'toDate']}
                                rules={[
                                  {
                                    required: false,
                                    message: 'To Date is required'
                                  }
                                ]}
                                // valuePropName for prevent error while setFieldValue
                                // and manual set DatePicker defaultValue
                                // only use for Form.List
                                valuePropName="date">
                                <DatePicker
                                  defaultValue={
                                    getFieldValue('trustee')[name]?.toDate
                                      ? moment(
                                          getFieldValue('trustee')[name]?.toDate
                                        )
                                      : null
                                  }
                                  disabled={
                                    !getFieldValue('trustee')[name]?.fromDate
                                  }
                                  disabledDate={(e) =>
                                    e &&
                                    e <
                                      moment(
                                        getFieldValue('trustee')[name]?.fromDate
                                      ).endOf('day')
                                  }
                                  // disabledDate={(e) => e && e > moment().endOf('day')}
                                />
                              </Form.Item>
                            )}
                          </Form.Item>
                        </Col> */}

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "individualCompany"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgIndComp"
                                ),
                              },
                            ]}
                          >
                            <Select
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.indComp"
                              )}
                            >
                              <Select.Option value="individual">
                                {Locale.get(
                                  "ownedPolicies.nominationTab.individual"
                                )}
                              </Select.Option>
                              <Select.Option value="company">
                                {Locale.get(
                                  "ownedPolicies.nominationTab.company"
                                )}
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "identityNumber"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgIdenNo"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.idenNo"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "identityType"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgIdenType"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.idenType"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={10} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "name"]}
                            rules={[
                              {
                                required: true,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgIndComp"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.indCompName"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            // hasFeedback
                            // label={'Contact :'}
                            name={[name, "contactNumber"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgContactNo"
                                ),
                              },
                              // {
                              //   min: 9,
                              //   message:
                              //     "Contact Number must not less than 9 digit",
                              // },
                              // {
                              //   max: 12,
                              //   message:
                              //     "Contact Number no must not more than 12 digit",
                              // },
                              // {
                              //   pattern: RegExp(/^\d+$/),
                              //   message: "Contact Number must be number only",
                              // },

                              // {
                              //   validator: (rule, value) => {
                              //     if (value.length === 10 || value.length === 11) {
                              //       return Promise.resolve();
                              //     } else {
                              //       return Promise.reject(
                              //         "Contact number must between 10 or 11 digits"
                              //       );
                              //     }
                              //   },
                              // },
                            ]}
                          >
                            <Input
                              /* prefix="+60" */ /* placeholder="01234567890" */ placeholder={Locale.get(
                                "ownedPolicies.nominationTab.contactNo"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={2} style={FormStyle}>
                          <Row justify="center">
                            <Button
                              type="link"
                              style={{ color: "red" }}
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                            >
                              {Locale.get("ownedPolicies.nominationTab.delete")}
                            </Button>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => (
                      <Row
                        style={{
                          // borderTop: '1px solid rgba(0,0,0,0.05)',
                          marginTop: 32,
                          // paddingTop: 24,
                          marginLeft: 32,
                          // width: window.innerWidth < ScreenSize.xl ? "400%" : "200%"
                        }}
                      >
                        <Col>
                          <Button
                            style={{
                              width: 300,
                              borderColor: "#d7a301",
                              color: "#d7a301",
                            }}
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            {Locale.get(
                              "ownedPolicies.nominationTab.addFieldButton"
                            )}
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
        </div>
      </SectionCard>
    </SectionContainer>
  );

  const AssigneeDetails = (
    <SectionContainer>
      <SectionCard
        loading={isConstantsLoading}
        title={Locale.get("ownedPolicies.nominationTab.assigneeDetail")}
        // buttonText="Add Nominee"
        // onActionButtonClick={() => setShowNomineeModal(true)}
      >
        <div
          style={{
            marginBottom: 24,
            border: "1px solid rgba(0,0,0,0.05)",
            overflowX: "auto",
            fontSize: 12,
          }}
        >
          <Row
            style={{
              height: 50,
              width: window.innerWidth < ScreenSize.xl ? "600%" : "100%",
            }}
          >
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.indComp")}
            </Col>
            <Col span={4} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.assignType")}
            </Col>
            <Col span={7} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.assignName")}
            </Col>
            <Col span={4} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.condAbsolute")}
            </Col>
            <Col span={4} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.relationship")}
            </Col>

            <Col span={2} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.action")}
            </Col>
          </Row>

          <div>
            <Form.List name="assignee">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => {
                    // console.log(key, name);

                    return (
                      <Row
                        key={key}
                        style={{
                          width:
                            window.innerWidth < ScreenSize.xl ? "600%" : "100%",
                        }}
                      >
                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "individualCompany"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgIndComp"
                                ),
                              },
                            ]}
                          >
                            <Select
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.indComp"
                              )}
                            >
                              <Select.Option value="individual">
                                {Locale.get(
                                  "ownedPolicies.nominationTab.individual"
                                )}
                              </Select.Option>
                              <Select.Option value="company">
                                {Locale.get(
                                  "ownedPolicies.nominationTab.company"
                                )}
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={4} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "assignType"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgAssignType"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.assignType"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={7} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "assigneeName"]}
                            rules={[
                              {
                                required: true,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgAssignName"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.assignName"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "conditionAbsolute"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgCondAbsolute"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.condAbsolute"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "relationship"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgRelationship"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.relationship"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        {/* <Col span={2} style={FormStyle}>
                          <Form.Item noStyle shouldUpdate>
                            {({ getFieldValue }) => (
                              <Form.Item
                                {...restField}
                                name={[name, 'effectDate']}
                                rules={[
                                  {
                                    required: false,
                                    message: 'Effect Date is required'
                                  }
                                ]}
                                // valuePropName for prevent error while setFieldValue
                                // and manual set DatePicker defaultValue
                                // only use for Form.List
                                valuePropName="date">
                                <DatePicker
                                  defaultValue={
                                    getFieldValue('assignee')[name]?.effectDate
                                      ? moment(
                                          getFieldValue('assignee')[name]
                                            ?.effectDate
                                        )
                                      : null
                                  }
                                />
                              </Form.Item>
                            )}
                          </Form.Item>
                        </Col> */}

                        {/* <Col span={2} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, 'serviceTaxImposed']}
                            rules={[
                              {
                                required: false,
                                message: 'Serv.Tax Imposed is required'
                              }
                            ]}>
                            <Input placeholder="Serv.Tax Imposed" />
                          </Form.Item>
                        </Col> */}

                        {/* <Col span={2} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, 'status']}
                            rules={[
                              { required: false, message: 'Status is required' }
                            ]}>
                            <Input placeholder="Status" />
                          </Form.Item>
                        </Col> */}

                        <Col span={2} style={FormStyle}>
                          <Row justify="center">
                            <Button
                              type="link"
                              style={{ color: "red" }}
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                            >
                              {Locale.get("ownedPolicies.nominationTab.delete")}
                            </Button>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => (
                      <Row
                        style={{
                          // borderTop: '1px solid rgba(0,0,0,0.05)',
                          marginTop: 32,
                          // paddingTop: 24,
                          marginLeft: 32,
                          // width: window.innerWidth < ScreenSize.xl ? "400%" : "200%"
                        }}
                      >
                        <Col>
                          <Button
                            style={{
                              width: 300,
                              borderColor: "#d7a301",
                              color: "#d7a301",
                            }}
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            {Locale.get(
                              "ownedPolicies.nominationTab.addFieldButton"
                            )}
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
        </div>
      </SectionCard>
    </SectionContainer>
  );

  const ContingentOwner = (
    <SectionContainer>
      <SectionCard
        loading={isConstantsLoading}
        title={Locale.get("ownedPolicies.nominationTab.contingentOwner")}
        // buttonText="Add Nominee"
        // onActionButtonClick={() => setShowNomineeModal(true)}
      >
        <div
          style={{
            marginBottom: 24,
            border: "1px solid rgba(0,0,0,0.05)",
            overflowX: "auto",
            fontSize: 12,
          }}
        >
          <Row
            style={{
              height: 50,
              width: window.innerWidth < ScreenSize.xl ? "600%" : "100%",
            }}
          >
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.idenType")}
            </Col>
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.idenNo")}
            </Col>
            <Col span={9} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.name")}
            </Col>
            <Col span={4} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.relationLifeAssured")}
            </Col>
            <Col span={3} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.contactNo")}
            </Col>
            <Col span={2} style={LabelStyle}>
              {Locale.get("ownedPolicies.nominationTab.action")}
            </Col>
          </Row>

          <div>
            <Form.List name="contingent">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => {
                    // console.log(key, name);
                    // console.log(form.getFieldValue('nomination'));

                    return (
                      <Row
                        key={key}
                        style={{
                          width:
                            window.innerWidth < ScreenSize.xl ? "600%" : "100%",
                        }}
                      >
                        {/* <Col span={2} style={FormStyle}>
                          <Form.Item noStyle shouldUpdate>
                            {({ setFieldsValue, getFieldValue }) => (
                              <Form.Item
                                {...restField}
                                name={[name, 'fromDate']}
                                rules={[
                                  {
                                    required: false,
                                    message: 'From Date is required'
                                  }
                                ]}
                                // valuePropName for prevent error while setFieldValue
                                // and manual set DatePicker defaultValue
                                // only use for Form.List
                                valuePropName="date">
                                <DatePicker
                                  defaultValue={
                                    getFieldValue('contingent')[name]?.fromDate
                                      ? moment(
                                          getFieldValue('contingent')[name]
                                            ?.fromDate
                                        )
                                      : null
                                  }
                                  onChange={(e) => {
                                    if (!e || e) {
                                      form.setFields([
                                        {
                                          name: ['contingent', name, 'toDate'],
                                          value: null
                                        }
                                      ]);
                                    }
                                  }}
                                />
                              </Form.Item>
                            )}
                          </Form.Item>
                        </Col>

                        <Col span={2} style={FormStyle}>
                          <Form.Item noStyle shouldUpdate>
                            {({ getFieldValue }) => (
                              <Form.Item
                                {...restField}
                                name={[name, 'toDate']}
                                rules={[
                                  {
                                    required: false,
                                    message: 'To Date is required'
                                  }
                                ]}
                                // valuePropName for prevent error while setFieldValue
                                // and manual set DatePicker defaultValue
                                // only use for Form.List
                                valuePropName="date">
                                <DatePicker
                                  defaultValue={
                                    getFieldValue('contingent')[name]?.toDate
                                      ? moment(
                                          getFieldValue('contingent')[name]
                                            ?.toDate
                                        )
                                      : null
                                  }
                                  disabled={
                                    !getFieldValue('contingent')[name]?.fromDate
                                  }
                                  disabledDate={(e) =>
                                    e &&
                                    e <
                                      moment(
                                        getFieldValue('contingent')[name]
                                          ?.fromDate
                                      ).endOf('day')
                                  }
                                  // disabledDate={(e) => e && e > moment().endOf('day')}
                                />
                              </Form.Item>
                            )}
                          </Form.Item>
                        </Col> */}

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "identityType"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgIdenType"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.idenType"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "identityNumber"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgIdenNo"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.idenNo"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={9} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "name"]}
                            rules={[
                              {
                                required: true,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgName"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.name"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4} style={FormStyle}>
                          <Form.Item
                            {...restField}
                            name={[name, "relationship"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgRelationLifeAssured"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={Locale.get(
                                "ownedPolicies.nominationTab.relationLifeAssured"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3} style={FormStyle}>
                          <Form.Item
                            // hasFeedback
                            // label={'Contact :'}
                            name={[name, "contactNumber"]}
                            rules={[
                              {
                                required: false,
                                message: Locale.get(
                                  "ownedPolicies.nominationTab.errMsgContactNo"
                                ),
                              },
                              // {
                              //   min: 9,
                              //   message:
                              //     "Contact Number must not less than 9 digit",
                              // },
                              // {
                              //   max: 12,
                              //   message:
                              //     "Contact Number no must not more than 12 digit",
                              // },
                              // {
                              //   pattern: RegExp(/^\d+$/),
                              //   message: "Contact Number must be number only",
                              // },

                              // {
                              //   validator: (rule, value) => {
                              //     if (value.length === 10 || value.length === 11) {
                              //       return Promise.resolve();
                              //     } else {
                              //       return Promise.reject(
                              //         "Contact number must between 10 or 11 digits"
                              //       );
                              //     }
                              //   },
                              // },
                            ]}
                          >
                            <Input
                              /* prefix="+60" */ /* placeholder="01234567890" */ placeholder={Locale.get(
                                "ownedPolicies.nominationTab.contactNo"
                              )}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={2} style={FormStyle}>
                          <Row justify="center">
                            <Button
                              type="link"
                              style={{ color: "red" }}
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                            >
                              {Locale.get("ownedPolicies.nominationTab.delete")}
                            </Button>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => (
                      <Row
                        style={{
                          // borderTop: '1px solid rgba(0,0,0,0.05)',
                          marginTop: 32,
                          // paddingTop: 24,
                          marginLeft: 32,
                          // width: window.innerWidth < ScreenSize.xl ? "400%" : "200%"
                        }}
                      >
                        <Col>
                          <Button
                            style={{
                              width: 300,
                              borderColor: "#d7a301",
                              color: "#d7a301",
                            }}
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            {Locale.get(
                              "ownedPolicies.nominationTab.addFieldButton"
                            )}
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
        </div>
      </SectionCard>
    </SectionContainer>
  );

  return (
    <>
      {NomidationDetails}
      {TrusteeDetails}
      {AssigneeDetails}
      {ContingentOwner}

      {/* <SectionContainer>
        <SectionCard
          loading={isConstantsLoading}
          title="Nomination"
          buttonText="Add Nominee"
          onActionButtonClick={() => setShowNomineeModal(true)}>
          <Row gutter={16}>
            <Table
              dataSource={nominations}
              columns={constructNominationsTableColumns(
                relationships,
                nominationTypes
              )}
              pagination={false}
              rowKey={(record) => record.name}
              showHeader={false}
              style={{ width: '100%' }}
              onRow={(record, index) => {
                return {
                  onClick: () => handleOnNomineeRowSelect(index)
                };
              }}
            />
          </Row>
        </SectionCard>
      </SectionContainer>
      {showNomineeModal && (
        <AddNomineeModal
          defaultValues={
            selectedNomineeIndex > -1 && nominations[selectedNomineeIndex]
          }
          onClose={handleOnAddNomineeModalCloseButtonClick}
          onOk={handleOnAddNomineeModalOkButtonClick}
          onRemove={handleOnAddNomineeModalRemoveButtonClick}
          visible={showNomineeModal}
        />
      )} */}
    </>
  );
};

export default Nomination;
